import React, { useState } from 'react';
import { LeafIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { TrustBadges } from './TrustBadges';
export function HeroSection() {
  const checkoutUrl = 'https://ewordmedia.com/cart/48415277515004:1?checkout';
  const [currentSlide, setCurrentSlide] = useState(0);
  const images = [{
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/cuUK9whpqZKDrtB58QRAYa/Natural_Health_Book_Collection-3-Bonus.png',
    alt: 'Natural Health Book Collection Bonus'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/9THoVYY7QY5WaNUGVh1gqT/Natural_Remedies_and_Herbal_Healing-Lifestyle.png',
    alt: 'Natural Remedies Lifestyle'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/44L3QbvhQCfkmAG21jDGvy/Natural_Remedies_and_Herbal_Healing-3.png',
    alt: 'Natural Remedies Guide'
  }];
  const nextSlide = () => {
    setCurrentSlide(prev => (prev + 1) % images.length);
  };
  const prevSlide = () => {
    setCurrentSlide(prev => (prev - 1 + images.length) % images.length);
  };
  return <section className="w-full bg-gradient-to-b from-emerald-50 to-stone-50 py-12 md:py-20" data-id="element-431">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-432">
        <div className="text-center" data-id="element-433">
          <div className="flex items-center justify-center gap-2 mb-4" data-id="element-434">
            <LeafIcon className="w-6 h-6 text-emerald-700" data-id="element-435" />
            <span className="text-emerald-700 font-medium" data-id="element-436">
              Natural Healing
            </span>
          </div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-stone-900 mb-6 leading-tight" data-id="element-437">
            The Natural Remedy Survival Guide
          </h1>
          <div className="flex items-center justify-center gap-3 mb-6" data-id="element-438">
            <LeafIcon className="w-6 h-6 text-emerald-700 flex-shrink-0" data-id="element-439" />
            <p className="text-xl md:text-2xl text-stone-700 leading-relaxed" data-id="element-440">
              Discover the Lost Healing Secrets Hidden in Your Kitchen Cabinet…
            </p>
          </div>
          <p className="text-lg text-stone-600 mb-8" data-id="element-441">
            (And why modern medicine never told you about them)
          </p>
          <div className="space-y-3 mb-4" data-id="element-442">
            <a href={checkoutUrl} data-cta="hero" onClick={() => {
            if (typeof window !== 'undefined' && (window as any).fbq) {
              ;
              (window as any).fbq('track', 'AddToCart');
            }
          }} className="inline-block w-full md:w-auto bg-gradient-to-r from-emerald-500 to-emerald-600 hover:from-emerald-600 hover:to-emerald-700 focus:from-emerald-600 focus:to-emerald-700 focus:outline-none focus:ring-4 focus:ring-emerald-300 text-white px-10 py-5 rounded-2xl text-lg font-bold transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-[1.02] focus:shadow-xl focus:scale-[1.02] transform" data-id="element-443">
              <span className="flex items-center justify-center gap-2" data-id="element-444">
                <span data-id="element-445">Only $17 Today</span>
                <span className="text-xl" data-id="element-446">›</span>
              </span>
            </a>
            <p className="text-center text-stone-600" data-id="element-447">
              <span className="font-semibold" data-id="element-448">Total value: </span>
              <span className="line-through text-stone-500" data-id="element-449">$51</span>
              <span className="text-emerald-600 font-semibold" data-id="element-450">
                {' '}
                • You save $34
              </span>
            </p>
          </div>
          <div className="mb-12" data-id="element-451">
            <TrustBadges data-id="element-452" />
          </div>
          <div className="relative max-w-md mx-auto" data-id="element-453">
            <div className="overflow-hidden rounded-lg shadow-2xl" data-id="element-454">
              <div className="flex transition-transform duration-500 ease-in-out" style={{
              transform: `translateX(-${currentSlide * 100}%)`
            }} data-id="element-455">
                {images.map((image, index) => <div key={index} className="w-full flex-shrink-0" data-id="element-456">
                    <img src={image.url} alt={image.alt} className="w-full h-auto object-contain" data-id="element-457" />
                  </div>)}
              </div>
            </div>
            <button onClick={prevSlide} className="absolute left-2 top-1/2 -translate-y-1/2 bg-white/95 hover:bg-white focus:bg-white focus:outline-none focus:ring-4 focus:ring-emerald-300 p-3 rounded-full shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-110 focus:scale-110 transform" aria-label="Previous image" data-id="element-458">
              <ChevronLeftIcon className="w-6 h-6 text-emerald-700" data-id="element-459" />
            </button>
            <button onClick={nextSlide} className="absolute right-2 top-1/2 -translate-y-1/2 bg-white/95 hover:bg-white focus:bg-white focus:outline-none focus:ring-4 focus:ring-emerald-300 p-3 rounded-full shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-110 focus:scale-110 transform" aria-label="Next image" data-id="element-460">
              <ChevronRightIcon className="w-6 h-6 text-emerald-700" data-id="element-461" />
            </button>
            <div className="flex justify-center gap-2 mt-4" data-id="element-462">
              {images.map((_, index) => <button key={index} onClick={() => setCurrentSlide(index)} className={`h-2.5 rounded-full transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2 ${currentSlide === index ? 'bg-emerald-700 w-8' : 'bg-stone-300 hover:bg-stone-400 w-2.5'}`} aria-label={`Go to slide ${index + 1}`} data-id="element-463" />)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}